import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "full-width" }
const _hoisted_2 = {
  class: "temlate-report",
  id: "oil-pressure-template-content"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { "data-excelsheet": "Суммарный охл. жидкость ДВС" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "q-ml-xs q-mt-sm text-bold",
  innerHTML: 
              'Суммарные данные давления масла ДВС по температуре охлаждающей жидкости ДВС'
            
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { "data-excelsheet": "Суммарный по маслу ДВС" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "q-ml-xs q-mt-sm text-bold",
  innerHTML: 
              'Суммарные данные давления масла ДВС по температуре масла ДВС'
            
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { "data-excelsheet": "По дням охл. жидкость ДВС" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "q-ml-xs q-mt-sm text-bold",
  innerHTML: 
              `Детализация по дням давления масла ДВС по температуре охлаждающей жидкости ДВС`
            
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { "data-excelsheet": "По дням масло ДВС" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "q-ml-xs q-mt-sm text-bold",
  innerHTML: 
              `Детализация по дням давления масла ДВС по температуре масла ДВС`
            
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { "data-excelsheet": "Суммарный температура масла" }, null, -1)
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { "data-excelsheet": "Детализация температура масла" }, null, -1)
const _hoisted_14 = ["innerHTML"]

import { computed, ref, nextTick, onMounted } from 'vue';

import UiTitle from './UiTitle.vue';
import PressureTable, { Filters } from './PressureTable.vue';
import OilPressureDetailPopup, {
  Props as DetailPopupProps,
} from './Popup/OilPressureDetailPopup.vue';

import OilPressure, {
  DayPressure,
  Interval,
  ObjectPressure,
  ReportCalculated,
  ReportName,
} from '@/Template/OilPressure/OilPressure';
import {
  SUMMARY_FORMAT_TYPES,
  ENGINE_OIL_TEMP_FORMAT_TYPES,
  FORMAT_TYPES,
  SUMMARY_COLUMNS,
  DAYS_COLUMNS,
  ENGINE_OIL_TEMP_SUMMARY_COLUMNS,
  RETARDER_OIL_TEMP_SUMMARY_COLUMNS,
  ENGINE_OIL_TEMP_DAYS_COLUMNS,
  RETARDER_OIL_TEMP_DAYS_COLUMNS,
} from './Columns';
import {
  formatDateHelper,
  getNeighborByClass_helper,
  wait,
} from '@/helpers/main_helper';
import { html_to_excel_helper } from '@/helpers/html_to_excel_helper';

export type Props = {
  data: ReportCalculated & {
    isSummary?: boolean;
    isDays?: boolean;
  };
  name: ReportName;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'OilPressureTemplate',
  props: {
    data: null,
    name: null
  },
  setup(__props: any) {

const props = __props as {
  data: ReportCalculated & {
    isSummary?: boolean;
    isDays?: boolean;
  };
  name: ReportName;
}



const getFullDate = (val: number | string) => {
  return formatDateHelper(new Date(+val * 1000), 'dd.mm.yyyy hh:nn:ss');
};

const detailPopup = ref<DetailPopupProps>({
  modelValue: false,
  status: {
    label: '',
    error: false,
    request: false,
  },
  retryHandler: null,
  label: '',
  interval: '',
  motoIndex: -1,
  temperatureIndex: -1,
  pressureKey: 'e',
  detailKey: 'detail',
  filters: {},
  data: null,
});

const REPORT_LABEL = computed(() =>
  props.name === 'oilPressure'
    ? 'Давление масла по парку ТС'
    : props.name === 'engineOilTemp' ? 'Моточасы работы ДВС по температуре масла ДВС' : 'Моточасы работы ДВС по температуре масла ретардера',
);

onMounted(() => {
  const button = document.getElementById('get-template-button');
  const targetSpan = getNeighborByClass_helper(button, 'target-show-span');

  if (!button || !targetSpan) return;
  button.style.background = 'blue';
  targetSpan.innerHTML = 'Отчет выполнен';
});

const getInterval = (interval: Interval) => {
  const from = getFullDate(interval.from / 1000);
  const to = getFullDate(interval.to / 1000);

  return `с ${from} по ${to}`;
};

function displayDaysDetail(
  ...args: [ObjectPressure, number, number, number, string, Filters]
) {
  const [object, rowIndex, motoIndex, temperatureIndex, pressureKey, filters] =
    args;
  if (!object.pressure.days) return;

  detailPopup.value.modelValue = true;
  detailPopup.value.status.request = true;

  detailPopup.value.label = `${REPORT_LABEL.value} </br> Гос. № ${object.stateNumber}`;
  detailPopup.value.interval = getInterval(props.data.responseInterval);
  detailPopup.value.motoIndex = motoIndex;
  detailPopup.value.temperatureIndex = temperatureIndex;
  detailPopup.value.pressureKey = pressureKey === 'e' ? 'e' : 'o';
  detailPopup.value.detailKey = 'days';
  detailPopup.value.filters = filters;
  detailPopup.value.data = {
    objects: [object],
    responseInterval: props.data.responseInterval,
  };

  detailPopup.value.status.request = false;
}
async function displayDetail(
  ...args: [ObjectPressure, DayPressure, number, number, string, Filters]
) {
  const [object, row, motoIndex, temperatureIndex, pressureKey, filters] = args;
  if (!object.pressure.days) return;

  detailPopup.value.data = null;

  detailPopup.value.modelValue = true;
  detailPopup.value.status.request = true;

  const interval = {
    from: row.time * 1000,
    to: row.time * 1000 + 86400000,
  };

  detailPopup.value.label = `${REPORT_LABEL.value} </br> Гос. № ${object.stateNumber}`;
  detailPopup.value.interval = getInterval(interval);
  detailPopup.value.motoIndex = motoIndex;
  detailPopup.value.temperatureIndex = temperatureIndex;
  detailPopup.value.pressureKey = pressureKey === 'e' ? 'e' : 'o';
  detailPopup.value.detailKey = 'detail';
  detailPopup.value.filters = filters;

  await wait(0.5);

  const report = new OilPressure('oilPressure');
  report.onProcess((type, message, percent) => {
    if (type === 'error') {
      detailPopup.value.status.error = true;
      detailPopup.value.status.label = message;
      detailPopup.value.retryHandler = () => {
        displayDetail(...args);
      };
    } else {
      detailPopup.value.status.error = false;
      if (percent === 100) {
        detailPopup.value.status.label = `Обсчет данных для графика`;
      } else {
        detailPopup.value.status.label = message;
      }
    }
  });
  report.onSuccess((reportCalculated) => {
    detailPopup.value.data = reportCalculated;
    detailPopup.value.status.request = false;
  });

  report.getReport({
    objects: [object.id],
    from: interval.from,
    to: interval.to,
    objectsData: { [object.id]: object },
    isSummary: false,
    isDays: false,
    isDetail: true,
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "#diagnostic-section-reports" }, [
    _createElementVNode("button", {
      class: "not-print float-left",
      onClick: _cache[0] || (_cache[0] = 
        (e) =>
          _unref(html_to_excel_helper).export(
            e.target,
            'oil-pressure-template-content',
            _unref(REPORT_LABEL),
            'landscape',
          )
      )
    }, " Экспорт в EXCEL "),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(UiTitle, {
        title: _unref(REPORT_LABEL),
        interval: getInterval(__props.data.responseInterval),
        "subtitle-part": "температура охлаждающей жидкости ДВC, либо температура масла ДВС"
      }, null, 8, ["title", "interval"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      (props.name === 'oilPressure')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (props.data.isSummary)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_3,
                  _createVNode(UiTitle, {
                    title: _unref(REPORT_LABEL),
                    interval: getInterval(__props.data.responseInterval),
                    "subtitle-part": "температура охлаждающей жидкости ДВC",
                    hidden: ""
                  }, null, 8, ["title", "interval"]),
                  _hoisted_4,
                  _createVNode(PressureTable, {
                    "format-types": _unref(SUMMARY_FORMAT_TYPES),
                    columns: _unref(SUMMARY_COLUMNS),
                    objects: props.data.objects,
                    "handle-filters": true,
                    handler: (obj) => obj.pressure.summary,
                    templateName: props.name,
                    "pressure-key": "e",
                    onOnRowClick: displayDaysDetail
                  }, null, 8, ["format-types", "columns", "objects", "handler", "templateName"]),
                  _hoisted_5,
                  _createVNode(UiTitle, {
                    title: _unref(REPORT_LABEL),
                    interval: getInterval(__props.data.responseInterval),
                    hidden: "",
                    "subtitle-part": "температура масла ДВC"
                  }, null, 8, ["title", "interval"]),
                  _hoisted_6,
                  _createVNode(PressureTable, {
                    "format-types": _unref(SUMMARY_FORMAT_TYPES),
                    columns: _unref(SUMMARY_COLUMNS),
                    objects: props.data.objects,
                    "handle-filters": true,
                    handler: (obj) => obj.pressure.summary,
                    templateName: props.name,
                    "pressure-key": "o",
                    onOnRowClick: displayDaysDetail
                  }, null, 8, ["format-types", "columns", "objects", "handler", "templateName"])
                ], 64))
              : _createCommentVNode("", true),
            (props.data.isDays)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_7,
                  _createVNode(UiTitle, {
                    title: _unref(REPORT_LABEL),
                    interval: getInterval(__props.data.responseInterval),
                    hidden: "",
                    "subtitle-part": "температура охлаждающей жидкости ДВC"
                  }, null, 8, ["title", "interval"]),
                  _hoisted_8,
                  _createVNode(PressureTable, {
                    "format-types": _unref(FORMAT_TYPES),
                    columns: _unref(DAYS_COLUMNS),
                    objects: props.data.objects,
                    "handle-filters": true,
                    handler: (obj) => obj.pressure.days,
                    templateName: props.name,
                    "pressure-key": "e",
                    onOnRowClick: displayDetail
                  }, null, 8, ["format-types", "columns", "objects", "handler", "templateName"]),
                  _hoisted_9,
                  _createVNode(UiTitle, {
                    title: _unref(REPORT_LABEL),
                    interval: getInterval(__props.data.responseInterval),
                    hidden: "",
                    "subtitle-part": "температура масла ДВC"
                  }, null, 8, ["title", "interval"]),
                  _hoisted_10,
                  _createVNode(PressureTable, {
                    "format-types": _unref(FORMAT_TYPES),
                    columns: _unref(DAYS_COLUMNS),
                    objects: props.data.objects,
                    "handle-filters": true,
                    handler: (obj) => obj.pressure.days,
                    templateName: props.name,
                    "pressure-key": "o",
                    onOnRowClick: displayDetail
                  }, null, 8, ["format-types", "columns", "objects", "handler", "templateName"])
                ], 64))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      (props.name === 'engineOilTemp' || props.name === 'retarderOilTemp')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_11,
            _createVNode(UiTitle, {
              title: _unref(REPORT_LABEL),
              interval: getInterval(__props.data.responseInterval),
              "hide-subtitle": "",
              hidden: ""
            }, null, 8, ["title", "interval"]),
            _createElementVNode("div", {
              class: "q-ml-xs q-mt-sm text-bold",
              innerHTML: props.name === 'retarderOilTemp' ? `Суммарные данные по температуре масла ретардера` : `Суммарные данные по температуре масла ДВС`
            }, null, 8, _hoisted_12),
            _createVNode(PressureTable, {
              "format-types": _unref(ENGINE_OIL_TEMP_FORMAT_TYPES),
              columns: 
            props.name === 'retarderOilTemp'
              ? _unref(RETARDER_OIL_TEMP_SUMMARY_COLUMNS)
              : _unref(ENGINE_OIL_TEMP_SUMMARY_COLUMNS)
          ,
              objects: props.data.objects,
              "handle-filters": false,
              handler: (obj) => obj.pressure.engineOilTempSummary,
              templateName: props.name,
              "pressure-key": "e",
              onOnRowClick: displayDaysDetail
            }, null, 8, ["format-types", "columns", "objects", "handler", "templateName"]),
            _hoisted_13,
            _createVNode(UiTitle, {
              title: _unref(REPORT_LABEL),
              interval: getInterval(__props.data.responseInterval),
              "hide-subtitle": "",
              hidden: ""
            }, null, 8, ["title", "interval"]),
            _createElementVNode("div", {
              class: "q-ml-xs q-mt-sm text-bold",
              innerHTML: props.name === 'retarderOilTemp' ? `Детализация по дням по температуре масла ретардера` : `Детализация по дням по температуре масла ДВС`
            }, null, 8, _hoisted_14),
            _createVNode(PressureTable, {
              "format-types": _unref(ENGINE_OIL_TEMP_FORMAT_TYPES),
              columns: 
            props.name === 'retarderOilTemp'
              ? _unref(RETARDER_OIL_TEMP_DAYS_COLUMNS)
              : _unref(ENGINE_OIL_TEMP_DAYS_COLUMNS)
          ,
              objects: props.data.objects,
              "handle-filters": false,
              handler: (obj) => obj.pressure.engineOilTempDays,
              templateName: props.name,
              "pressure-key": "o",
              onOnRowClick: displayDetail
            }, null, 8, ["format-types", "columns", "objects", "handler", "templateName"])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createVNode(OilPressureDetailPopup, {
      modelValue: detailPopup.value.modelValue,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((detailPopup.value.modelValue) = $event)),
      status: detailPopup.value.status,
      label: detailPopup.value.label,
      interval: detailPopup.value.interval,
      "moto-index": detailPopup.value.motoIndex,
      "temperature-index": detailPopup.value.temperatureIndex,
      "pressure-key": detailPopup.value.pressureKey,
      "detail-key": detailPopup.value.detailKey,
      "retry-handler": detailPopup.value.retryHandler,
      filters: detailPopup.value.filters,
      data: detailPopup.value.data,
      templateName: props.name,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (detailPopup.value.modelValue = false))
    }, null, 8, ["modelValue", "status", "label", "interval", "moto-index", "temperature-index", "pressure-key", "detail-key", "retry-handler", "filters", "data", "templateName"])
  ]))
}
}

})